import { Component, Vue } from 'vue-property-decorator'

@Component

export default class UnregisteredUsers extends Vue {

  private namespace: string = '/Console';

  private users: {domains: string, activationCode: string} | null = null;

  private copiedCode: number = -1;

  beforeMount () {

    this.getUnregisteredUsers();
  }

  private copyActivationCode (index: number, item: {domains: string, activationCode: string}) {

    this.copiedCode = index;
    setTimeout(() => {
      this.copiedCode = -1;
    }, 1000);

    const temp = document.createElement('input');
    document.body.appendChild(temp);

    temp.value = item.activationCode;
    temp.select();

    document.execCommand('copy');
    document.body.removeChild(temp);
  }

  private async getUnregisteredUsers () {

    try {
      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/VirtualUsers`);

      this.users = response.data;

    } catch (err) {

      console.error(err);
    }
  }
}